import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import {
  validateEditMember,
  validateEditProfile,
} from "../../../constant/validation";
import { convertToDate, disableGender, getUser, onlyMobile, onlyNumber } from "../../../constant/utils";
import { useSelector } from "react-redux";
import moment from "moment";
interface IMember {
  open: boolean;
  editData: any;
  handleClose: () => void;
  handleSubmit: (data: any) => void;
}

const AddEditMemberChk = ({
  open,
  handleClose,
  handleSubmit,
  editData,
}: IMember) => {
  const USER: any = getUser();
  const [initialValue, setInitialValue] = useState<any>({
    first_name: "",
    last_name: "",
    relation: "",
    salutation: "",
    mobile_no: "",
    dob: "",
    gender: "",
    email_id: "",
  });
  const master: any = useSelector(
    (state: any) => state?.profile?.profileMaster || {}
  );
  const patientData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  const profileData: any = useSelector((state: any) =>
    state.profile.profileData ? state.profile.profileData : {}
  );

  ReactModal.setAppElement("body");
  useEffect(() => {
    if (!patientData?.pid) {
      setInitialValue({
        mobile_no: profileData?.mobile_no || USER?.MobileNo || "",
        relation: master?.relation?.[0]?.tag || "",
        first_name: profileData?.first_name || "",
        last_name: profileData?.last_name || "",
        dob: convertToDate(profileData?.dob) || "",
        gender: profileData?.gender?.toLowerCase() || "",
        salutation: profileData?.salutation || master?.salutation?.[0]?.tag || "1",
        email_id: profileData?.email_id || "",
      });
    } else {
      setInitialValue({
        first_name: editData?.first_name || "",
        last_name: editData?.last_name || "",
        mobile_no: editData?.mobile_no || "",
        dob: convertToDate(editData?.dob) || "",
        gender: editData?.gender?.toLowerCase() || "",
        relation: editData?.relation || "",
        salutation: editData?.salutation || master?.salutation?.[0]?.tag || "",
        email_id: editData?.email_id || profileData?.email_id || "",
      });
    }
  }, [editData]);

  function getRelationData(data: any[]) {
    if (checkSelf()) {
      return data?.filter((ele: any) => ele?.tag == "1");
    } else {
      return data?.filter((ele: any) => ele?.tag != "1");
    }
  }
  function checkSelf() {
    if (!patientData?.pid) {
      return true;
    } else if (editData?.pid) {
      return true;
    } else {
      return false;
    }
  }
  return (
    <ReactModal
      isOpen={open}
      /* style={customStyles} */
      onRequestClose={handleClose}
      className="my_acc_modal"
      overlayClassName="my_acc_overlay"
    >
      <div className="cross_button">
        <img
          src="/assets/img/my-profile/cross.png"
          alt=""
          className="cursor-pointer"
          onClick={handleClose}
        />
        <div className="acc_modal_content">
          <h6 className="pb-3">
            {editData?.id || editData?.pid
              ? "Edit Family Member"
              : "Add Family Member"}
          </h6>
          <div>
            <Formik
              initialValues={initialValue}
              enableReinitialize={true}
              validationSchema={
                checkSelf() ? validateEditProfile : validateEditMember
              }
              onSubmit={(val: any) => {
                handleSubmit(val);
              }}
              render={({
                values,
                handleChange,
                errors,
                touched,
                handleBlur,
                handleSubmit,
                setFieldValue
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row align-items-start">
                    <div className="col-sm-2">
                      <div className="form-group">
                        <label className="profileLabel">Salutation*</label>
                        <select
                          name="salutation"
                          className="form-control profileInp"
                          onChange={(e:any)=> {
                            handleChange(e);
                            setFieldValue("gender","");
                          }}
                          onBlur={handleBlur}
                          value={values?.salutation}
                        >
                          <option value=""> Select Salutation</option>
                          {master?.salutation?.map((ele: any) => (
                            <option value={ele?.tag}> {ele?.title}</option>
                          ))}
                        </select>
                        {touched?.salutation && errors?.salutation && (
                          <span className="error_message">
                            {errors?.salutation}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="profileLabel">First Name*</label>
                        <input
                          type="text"
                          name="first_name"
                          className="form-control profileInp"
                          placeholder="Enter First Name"
                          onChange={handleChange}
                          onBlur={(event) =>
                            setFieldValue(event.target.name, event.target.value.trim())
                         }
                          value={values?.first_name}
                          onInput={(e:any) => {return e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '').replace(/\s{2,}/g, ' ')}}
                        />
                        {touched?.first_name && errors?.first_name && (
                          <span className="error_message">
                            {errors?.first_name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Last Name*</label>
                        <input
                          type="text"
                          name="last_name"
                          className="form-control profileInp"
                          placeholder="Enter Last Name"
                          onChange={handleChange}
                          onBlur={(event) =>
                            setFieldValue(event.target.name, event.target.value.trim())
                         }
                          value={values?.last_name}
                          onInput={(e:any) => {return e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, '').replace(/\s{2,}/g, ' ')}}
                        />
                        {touched?.last_name && errors?.last_name && (
                          <span className="error_message">
                            {errors?.last_name}
                          </span>
                        )}
                      </div>
                    </div>
                    {checkSelf() && (
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="profileLabel">Email ID*</label>
                          <input
                            type="text"
                            name="email_id"
                            className="form-control profileInp"
                            placeholder="Enter Email ID"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.email_id}
                          />
                          {touched?.email_id && errors?.email_id && (
                            <span className="error_message">
                              {errors?.email_id}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Mobile Number*</label>
                        <input
                          type="text"
                          name="mobile_no"
                          className="form-control profileInp"
                          placeholder="Enter Mobile Number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.mobile_no}
                          onInput={onlyMobile}
                          maxLength={10}
                          disabled={checkSelf()}
                        />
                        {touched?.mobile_no && errors?.mobile_no && (
                          <span className="error_message">
                            {errors?.mobile_no}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Date of Birth*</label>
                        <input
                          type="date"
                          name="dob"
                          className="form-control profileInp"
                          placeholder="Select DOB"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.dob}
                          min={moment()
                            .subtract(120, "years")
                            ?.format("YYYY-MM-DD")}
                          max={moment()
                            .subtract(5, "years")
                            ?.format("YYYY-MM-DD")}
                        />
                        {touched?.dob && errors?.dob && (
                          <span className="error_message">{errors?.dob}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Gender*</label>
                        <div>
                          {master?.gender?.map((ele: any,idx:number) => (
                            <div className="form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id={`flexRadioDefault${idx}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={ele?.tag}
                                checked={ele?.tag == values?.gender}
                                disabled={disableGender(ele?.tag, values?.salutation)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`flexRadioDefault${idx}`}
                              >
                                {ele?.title}
                              </label>
                            </div>
                          ))}
                        </div>
                        {touched?.gender && errors?.gender && (
                          <span className="error_message">
                            {errors?.gender}
                          </span>
                        )}
                      </div>
                    </div>
                    {!checkSelf() && (
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="profileLabel">
                            Select Relation*
                          </label>
                          <select
                            name="relation"
                            className="form-control profileInp"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.relation}
                          >
                            <option value=""> Select Relation</option>
                            {getRelationData(master?.relation)?.map(
                              (ele: any, i: any) => {
                                return (
                                  <option value={ele?.tag}>
                                    {" "}
                                    {ele?.title}
                                  </option>
                                );
                              }
                            )}
                          </select>
                          {touched?.relation && errors?.relation && (
                            <span className="error_message">
                              {errors?.relation}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="book--hexagon active sm_form"
                      >
                        <span>
                          {editData?.id || editData?.pid ? "Update" : "Save"}
                          <i
                            className="fa fa-long-arrow-right ml-20"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default AddEditMemberChk;
